import { useApiConfig } from '../useApiConfig';
import { PROJECT_PRESETS_QUERY_KEY } from '../../utils/consts';
import { useQueryClient } from '@tanstack/react-query';
import {
  ProjectPresets,
  ProjectPresetsApi,
} from 'osep-generator-service-client-v1';

function useCreateProjectPresetsMutation() {
  const { getApiConfig, axiosInstance } = useApiConfig();
  const queryClient = useQueryClient();

  const createProjectPresets = async (projectPresets: ProjectPresets) => {
    const config = await getApiConfig();
    const api = new ProjectPresetsApi(config, undefined, axiosInstance);

    const response = await api.setProjectPresets(projectPresets);
    await queryClient.invalidateQueries({
      predicate: (query) => query.queryKey.includes(PROJECT_PRESETS_QUERY_KEY),
    });

    return response.data;
  };

  return { createProjectPresets };
}

export default useCreateProjectPresetsMutation;
